module.exports = __webpack_public_path__ + "media/boschautoparts/logo-3-4b1bdfee.png";